import "../styles/default.scss";

import classNames from "classnames";
import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import FormatCurrency from "../../Homepage/components/FormatCurrency";
import RadioDot from "../../Homepage/components/RadioDot";
import getCurrencyOfferByPeriod from "../utils/getCurrencyOfferByPeriod";
import Period from "./Period";
import { getPaymentMethodPricing } from "../utils/useOnPaymentButtonClick";

const PlanBoxSquare = ({
  plan,
  isCurrentPlan,
  isSelectedPlan,
  isRecommendedPlan,
  isHighlightedPlan,
  onSelect,
  locale,
  translate,
  isAvailableInPlan,
  period,
  selectedPaymentMethod,
  description
}) => {
  const currencyOffer = getCurrencyOfferByPeriod({
    currency_offers: plan.currency_offers,
    period: period
  });

  if (!currencyOffer) {
    return null;
  }

  const paymentMethodPricing = getPaymentMethodPricing({
    currentCurrencyOfferByPeriod: currencyOffer,
    selectedPaymentMethod: selectedPaymentMethod
  });

  const isGuaranteedUserOffer = currencyOffer?.is_guaranteed_user_offer;
  const originalCurrencyOffer = isGuaranteedUserOffer
    ? currencyOffer.original_currency_offer
    : undefined;
  const bonus = plan?.bonus?.[0];

  return (
    <button
      onClick={onSelect}
      className={classNames("plan-box w-full", {
        "plan-box_current": isCurrentPlan,
        "plan-box_highlighted": !isCurrentPlan && isHighlightedPlan,
        "plan-box_available": isAvailableInPlan,
        "plan-box_selected": isSelectedPlan
      })}
    >
      <div
        className={classNames("plan-tag", {
          "plan-tag_current": isCurrentPlan,
          "plan-tag_guaranteed-user-offer":
            !isCurrentPlan && isGuaranteedUserOffer,
          "plan-tag_available":
            !isCurrentPlan && !isGuaranteedUserOffer && isAvailableInPlan,
          "plan-tag_recommended":
            !isCurrentPlan &&
            !isGuaranteedUserOffer &&
            !isAvailableInPlan &&
            isRecommendedPlan
        })}
      >
        {isCurrentPlan
          ? translate("plans_box_current-plan")
          : isGuaranteedUserOffer
          ? translate("plans_box_guaranteed-user-offer")
          : isAvailableInPlan
          ? translate("plans_box_available-in-plan")
          : isRecommendedPlan
          ? translate("plans_box_recommended")
          : null}
      </div>
      <div className={"content"}>
        <div className={"flex align-center justify-between mb-3"}>
          <strong className={"text-xl.1 font-semibold text-black"}>
            {plan.name}
          </strong>
          <RadioDot isSelected={isSelectedPlan} />
        </div>
        {description ? (
          description
        ) : (
          <p className={"description"}>{plan.description}</p>
        )}
        <hr />
        {currencyOffer ? (
          <div className={"flex flex-col"}>
            {paymentMethodPricing?.order_monthly_amount !==
            paymentMethodPricing?.monthly_amount ? (
              <strong
                className={
                  "ml-auto text-xl font-bold text-red-1 line-through ml-auto"
                }
              >
                <FormatCurrency
                  value={paymentMethodPricing.monthly_amount}
                  locale={locale}
                />
              </strong>
            ) : null}
            <div className={"final-price-wrapper"}>
              <strong className={"final-price"}>
                <FormatCurrency
                  value={paymentMethodPricing?.order_monthly_amount ?? 0}
                  locale={locale}
                />
              </strong>
              <div className={"flex flex-col w-full"}>
                <span className={"text-xs text-black-5"}>
                  <Period periods={1} />
                </span>
              </div>
            </div>
          </div>
        ) : null}
        {currencyOffer?.omnibus_price ? (
          <div>
            <span
              className={"text-xs.1 text-black opacity-50 mt-1.5 mb-3 flex"}
            >
              {translate("plans_box_omnibus-price", {
                value: FormatCurrency({
                  value: currencyOffer.omnibus_price,
                  locale
                })
              })}
            </span>
          </div>
        ) : null}
        {isGuaranteedUserOffer ? (
          <div
            className={classNames(
              "text-xs.1 text-black opacity-50 mb-3 mt-1.5 flex",
              { "h-4": !isGuaranteedUserOffer }
            )}
          >
            <span>
              {translate("plans_box_guaranteed-user-offer-description", {
                originalPrice: FormatCurrency({
                  value: originalCurrencyOffer.offer_amount,
                  locale
                }),
                discount: FormatCurrency({
                  value:
                    originalCurrencyOffer.offer_amount -
                    currencyOffer.offer_amount,
                  locale
                })
              })}
            </span>
          </div>
        ) : null}
        {bonus?.items?.length > 0 ? (
          <div className={"text-xs.1 mt-1.5"}>
            <strong className={"font-semibold text-black uppercase"}>
              {translate("plans_box_bonus")}
            </strong>
            <span className={"font-semibold text-black opacity-65"}>
              {bonus.items.map(({ title }) => title).join(" + ")}
            </span>
          </div>
        ) : null}
      </div>
    </button>
  );
};

export default compose(withTranslations)(PlanBoxSquare);
